import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  Agendamento,
  FormAgendamento,
  HorariosDisponiveisAgendamento,
  LocalAgendamento,
} from '../models/agendamento.model';

@Injectable({
  providedIn: 'root',
})
export class AgendamentoService {
  constructor(private http: HttpClient) {}

  getLocais(): Observable<LocalAgendamento[]> {
    const URL = `/api/agendamento/locais`;
    return this.http
      .get<LocalAgendamento[]>(URL)
      .pipe(
        map((locais) => locais.map((l) => new LocalAgendamento(l.id, l.nome)))
      );
  }

  getHorarios(id: number): Observable<HorariosDisponiveisAgendamento[]> {
    const URL = `/api/agendamento/horario/${id}`;
    return this.http
      .get<HorariosDisponiveisAgendamento[]>(URL)
      .pipe(
        map((horarios) =>
          horarios.map(
            (h) => new HorariosDisponiveisAgendamento(h.id, h.horario)
          )
        )
      );
  }

  postAgendamento(form: FormAgendamento) {
    console.log(form);
    const URL = `/api/agendamento`;
    return this.http
      .post<Agendamento>(URL, form)
      .pipe(
        map(
          (res) =>
            new Agendamento(res.id, res.ano, res.dataAgendamento, res.localNome)
        )
      );
  }
}
